<template>
  <pl-dialog :size="'md'" title="Discussion Questions" :disableOutsideClick="true" @close="saveGuidingQuestions">
    <div class="flex flex-col flex-grow h-full overflow-y-auto px-6 pb-6">
      <div v-for="(question, index) in new_guiding_questions" :key="index" class="flex space-x-12 items-start justify-between mb-6">
        <div class="flex items-start space-x-2">
          <div class="font-poppins font-semibold text-gray-800">{{ index + 1 }}.</div>
          <div class="font-poppins font-light text-gray-800">
            {{ question.question }}
          </div>
        </div>
        <div class="flex items-center">
          <div v-if="!editing_guiding_question" class="flex w-24 items-center justify-end space-x-3">
            <div class="sample">
              <button title="Edit" @click="editGuidanceQuestion(index, question)" class="rounded-full w-8 h-8 bg-gray-200 text-gray-800">
                <i class="fas fa-edit"></i>
              </button>
            </div>
            <div class="sample">
              <button title="Delete" @click="deleteGuidanceQuestion(index)" class="rounded-full w-8 h-8 bg-red-100 text-red-500">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
            <toggle-button
              :labels="false"
              :title="'Visible To Students'"
              v-model="question.is_active"
              color="#72ccd7"
              class="toggle-button-class"
            />

          </div>
        </div>
      </div>
      <div class="w-full flex flex-col space-y-2">
        <div class="w-full flex items-start space-x-2">
          <textarea
            rows="4"
            @keyup.enter="addEditQuestion"
            v-model="new_guiding_question.question"
            type="text"
            labelText=""
            placeholder="Add a question..."
            class="rounded font-poppins bg-white font-light px-3 py-2 text-gray-800 border border-solid border-gray-200 placeholder-gray-600 w-full"
          ></textarea>
          <button
            v-if="editing_guiding_question"
            class="sample h-9 px-3 bg-primary text-white rounded"
            @click="saveEditGuidanceQuestion"
          >
            Save
          </button>
          <button v-else @click="saveEditGuidanceQuestion" class="h-9 px-3 rounded bg-blueGray-800 text-white font-poppins">
            Add
          </button>
        </div>
        <div v-if="!editing_guiding_question" class="font-poppins font-light text-xs text-gray-700">
          Press + or enter to create question
        </div>
      </div>      
    </div>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        new_guiding_question: {
          is_active: true,
          question: '',
        },
        //new_guiding_question: '',
        guidingQuestionIndex: null,
        editing_guiding_question: false,
        editing_guiding_question_index: null,
        new_guiding_questions: [],
      };
    },
    computed: {
      ...mapGetters(['hasTeacherPermissionsInCourse', 'getCurrentDiscussion']),
    },
    methods: {
      addEditQuestion() {
        if (this.editing_guiding_question) {
          this.saveEditGuidanceQuestion();
        } else {
          this.createNewGuidingQuestion();
        }
      },
      createNewGuidingQuestion() {
        if (!this.new_guiding_question.question) {
          return;
        }
        this.new_guiding_questions.push({
          question: this.new_guiding_question.question,
          is_active: true,
          is_custom: true,
        });

        this.new_guiding_question.question = '';
      },
      editGuidanceQuestion(index, question) {
        this.editing_guiding_question = true;
        this.editing_guiding_question_index = index;
        this.new_guiding_question = Object.assign({}, question);
      },
      saveEditGuidanceQuestion() {
        this.new_guiding_questions[this.editing_guiding_question_index] = {
          question: this.new_guiding_question.question,
          is_active:
            this.new_guiding_questions[this.editing_guiding_question_index]
              .is_active,
          is_custom:
            this.new_guiding_questions[this.editing_guiding_question_index]
              .is_custom,
        };
        this.new_guiding_question.question = '';
        this.editing_guiding_question_index = null;
        this.editing_guiding_question = false;
      },
      deleteGuidanceQuestion(index) {
        this.new_guiding_questions.splice(index, 1);
      },
      saveGuidingQuestions: async function() {
        
        const toast = { type: '', message: '', time: 5000 };
        const discussionID = this.$route.params.liveDiscussionID;
        try {
          await this.$store.dispatch('saveLiveDiscussionSettings', { id: discussionID, toggleable_guiding_questions: this.new_guiding_questions });
          this.$emit('close');
        } catch (error) {
          toast.message = 'Something went wrong with questions, please try again.';
          toast.type = 'Error';
          EventBus.$emit('createToast', toast);
        }
      },
    },
    mounted() {
      this.new_guiding_questions = [
        ...this.getCurrentDiscussion.toggleable_guiding_questions,
      ];
    },
  };
</script>



// WEBPACK FOOTER //
// guidingQuestionsModal.vue?d20a0bc6